<template>
  <div>
    <Standard v-if="pageType == 'standard'" :id="id" :slug="slug" />
  </div>
</template>

<script>
    import Standard from "./Standard.vue"

    export default {
        props: ["id", "slug", "pageType"],
        components: {Standard}
    };
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-products/src/productPage/Manager.vue